export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white text-center py-6">
      <p>&copy; {new Date().getFullYear()} THERMOCOOL TECHNOLOGY MADAGASCAR - Tous droits réservés.</p>
    </footer>
  );
}
